import { useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo, useState } from 'react';
import DropdownComponent from '../../../components/Form/Dropdown';
import {
  useGetCopyMeConfigQuery,
  useSetBasketCopyMeMutation,
  useSetUserCopyMeMutation,
} from '../../../store/services/api';
import { selectUserId } from '../../../store/slices/user';
import ColoredCheckbox from '../../../components/ColoredCheckbox';
import { colors } from '../../../colors';

const BasketSettings = () => {
  const userId = useSelector(selectUserId);
  const { data: enableCopyMeTradingData, isLoading } =
    useGetCopyMeConfigQuery(userId);
  const [setUserPortfolioCopyMe] = useSetUserCopyMeMutation();
  const [setBasketCopyMe] = useSetBasketCopyMeMutation();

  const [baskets, setBaskets] = useState<
    | Array<{
        friendlyName: string;
        isPublic: number;
      }>
    | undefined
  >();
  const [selectedBasket, setSelectedBasket] = useState<
    | {
        friendlyName: string;
        isPublic: number;
      }
    | undefined
  >();

  useEffect(() => {
    if (!enableCopyMeTradingData) {
      return;
    }

    setBaskets(enableCopyMeTradingData);
    setSelectedBasket(enableCopyMeTradingData[0]);
  }, [enableCopyMeTradingData]);

  const allClusterFriendlyNames = useMemo(() => {
    if (!baskets) {
      return [];
    }

    return baskets?.map((b) => b.friendlyName);
  }, [baskets]);

  const handleBasketChange = useCallback(
    (friendlyName: string) => {
      setSelectedBasket(baskets?.find((b) => b.friendlyName === friendlyName));
    },
    [baskets],
  );

  const checkboxValue = useMemo(() => {
    return selectedBasket?.isPublic;
  }, [selectedBasket?.isPublic]);

  const handleToggleChange = useCallback(
    (value: boolean) => {
      console.log({ value, selectedBasket });
      if (!selectedBasket) {
        return;
      }

      setBaskets((prev) => {
        if (!prev) {
          return prev;
        }

        const updated = [...prev];
        const basketIndex = updated.findIndex(
          (b) => b.friendlyName === selectedBasket?.friendlyName,
        );

        if (basketIndex === -1) {
          return prev;
        }

        updated[basketIndex] = {
          friendlyName: updated[basketIndex].friendlyName,
          isPublic: value ? 1 : 0,
        };
        return updated;
      });

      setSelectedBasket({
        friendlyName: selectedBasket?.friendlyName,
        isPublic: value ? 1 : 0,
      });

      // Call backend with the change
      const isEntirePortfolio =
        selectedBasket.friendlyName === 'Entire Portfolio';

      if (isEntirePortfolio) {
        setUserPortfolioCopyMe({ userId, value });
      } else {
        setBasketCopyMe({ userId, basket: selectedBasket.friendlyName, value });
      }
    },
    [selectedBasket, setBasketCopyMe, setUserPortfolioCopyMe, userId],
  );

  return (
    <div style={{ padding: 46, paddingTop: 12, width: 'fit-content' }}>
      <p
        style={{
          color: 'white',
          fontWeight: 'bold',
          fontSize: 20,
          marginBottom: 5,
        }}
      >
        Enable Copy Me Trading
      </p>
      {/** Dropdown */}
      <DropdownComponent
        config={{
          label: 'Basket',
          value: selectedBasket?.friendlyName,
          handleValueChange: handleBasketChange,
          options: allClusterFriendlyNames,
          shouldFit: true,
        }}
      />
      {/** Checkbox */}
      <div style={{ display: 'flex', columnGap: 8, marginTop: 12 }}>
        <ColoredCheckbox
          value={checkboxValue === 1}
          handleValueChange={handleToggleChange}
          size={10}
          color={colors.white}
        />
        <span style={{ color: colors.white, fontWeight: 'bold' }}>
          Allow Copy Me Trading
        </span>
      </div>
    </div>
  );
};

export default BasketSettings;
